import Icon from '../components/Icon.vue'

Icon.register({
  trademark: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M97.1 163.1H12C5.4 163.1 0 157.8 0 151.1V108C0 101.4 5.4 96 12 96H260.6C267.2 96 272.6 101.4 272.6 108V151.1C272.6 157.8 267.2 163.1 260.6 163.1H175.4V404C175.4 410.6 170.1 416 163.4 416H109.1C102.5 416 97.1 410.6 97.1 404V163.1zM329.8 96H395.3A12-12 0 0 0 406.6 104.1L450.4 231.2C457.5 251.7 466.5 284 466.5 284H467.4S476.3 251.7 483.5 231.2L527.2 104.1A12-12 0 0 0 538.6 96H604A12-12 0 0 0 615.9 107L640 403C640.5 410 635 416 628 416H573.9A12-12 0 0 0 561.9 404.8L552.8 271.9C551.1 247.7 552.8 218.2 552.8 218.2H551.9S541.2 251.7 534 271.9L503.3 356.6A12-12 0 0 0 492.1 364.5H441.8A12-12 0 0 0 430.5 356.6L399.8 271.9C392.6 251.7 381.9 218.2 381.9 218.2H381S382.8 247.7 381 271.9L371.9 404.8C371.5 411.1 366.2 416 359.9 416H305.4C298.4 416 292.9 410 293.4 403L317.9 107A12-12 0 0 0 329.8 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trademark.js
// module id = evoT
// module chunks = 144